<template>
  <browse-filter>
    <browse-filter-checkbox
      label="Sumo Day"
      value="sumo-day"
      :checked="value"
      @click="select"
    >
      <template #label>
        <img
          class="logo"
          :src="SumoDayLogo"
          alt="Sumo Day"
        >
      </template>
    </browse-filter-checkbox>
  </browse-filter>
</template>
<script>
import SumoDayLogo from '~/static/sumoday-filter.svg';
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterCheckbox from './BrowseFilterCheckbox.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      SumoDayLogo,
    };
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked);
    },
  },
};
</script>
<style scoped>
em {
  font-style: normal;
  font-size: 12px;
}

.logo {
  height: 24px;
  vertical-align: middle;
}
</style>
